module.exports = __webpack_public_path__ + "img/keyboard-esc.10cc9934.svg";